import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  selectedSchoolDetailSelector,
  userDetailSelector,
  userNameSelector,
} from "app/modules/schools/selectors";
import { useNavigate } from "react-router-dom";
import CreateTicket from "app/modules/help-and-support/components/CreateTicket/CreateTicket";

const WIDGET_CODE =
  "siq7ecfcc376e5827110eba0964ffe5531fcc1bc8652d202932556046f97ac966293b0789384f01c4c0365fffacfb39ca13";

const ZohoSalesIQ = ({ user }) => {
  const userFullName = useSelector(userNameSelector);
  const userDetail = useSelector(userDetailSelector);
  const schoolInfo = useSelector(selectedSchoolDetailSelector);
  let userWidgetId = `${userDetail?._id}_${schoolInfo?._id}`;

  const [openTicketDialog, setOpenTicketDialog] = useState(false);

  const navigate = useNavigate();
  useEffect(() => {
    if (document.getElementById("zsiqscript")) return;

    if (window.$zoho && window.$zoho.salesiq) {
      try {
        window.$zoho.salesiq.floatwindow.visible("hide");
      } catch (e) {
        console.error("Error hiding Zoho SalesIQ float window:", e);
      }
    }

    window.$zoho = window.$zoho || {};
    window.$zoho.salesiq = window.$zoho.salesiq || {
      widgetcode: WIDGET_CODE,
      values: {},
    };

    const initializeZohoWidget = () => {
      try {
        if (userDetail) {
          
          window.$zoho.salesiq.visitor.email(userDetail?.email);
          window.$zoho.salesiq.visitor.id(userWidgetId);
          window.$zoho.salesiq.visitor.name(userFullName);
          window.$zoho.salesiq.visitor.info({
            personName: userFullName,
            // designation: userDetail.employmentInfo?.designation || "N/A",
            schoolDocID: schoolInfo?._id,
            schoolName: schoolInfo?.schoolName,
            personDocId: userDetail?._id,
          });
        }

        window.$zoho.salesiq.clientactions = {
          open_ticket_form: function () {
            try {
              window.$zoho.salesiq.floatwindow.visible("hide");
              setOpenTicketDialog(true);
            } catch (err) {
              console.error("Error opening ticket form:", err);
            }
          },
          open_my_tickets: function () {
            try {
              window.$zoho.salesiq.floatwindow.visible("hide");
              navigate("/help-and-support");
            } catch (err) {}
          },
        };

        const setHomeWidgets = () => {
          try {
            if (
              window.$zoho &&
              window.$zoho.salesiq &&
              typeof window.$zoho.salesiq.set === "function"
            ) {
              window.$zoho.salesiq.set("home.widgets", [
                {
                  type: "command_panel",
                  title: "Need Help?",
                  actions: [
                    {
                      type: "client_action",
                      label: "Create Support Ticket",
                      name: "ticketBtn",
                      clientaction_name: "open_ticket_form",
                    },
                    {
                      type: "client_action",
                      label: "Ticket's List",
                      name: "myTicketsBtn",
                      clientaction_name: "open_my_tickets",
                    },
                  ],
                },
              ]);
              return true;
            } else {
              return false;
            }
          } catch (err) {
            return false;
          }
        };

        let retryCount = 0;
        const maxRetries = 10;

        const retrySetWidgets = () => {
          if (retryCount >= maxRetries) {
            return;
          }

          retryCount++;

          if (!setHomeWidgets()) {
            setTimeout(retrySetWidgets, 1000 * retryCount);
          }
        };

        retrySetWidgets();

        setTimeout(() => {
          if (retryCount < maxRetries) retrySetWidgets();
        }, 2000);

        setTimeout(() => {
          if (retryCount < maxRetries) retrySetWidgets();
        }, 5000);

        window.$zoho.salesiq.floatwindow.visible("hide");
      } catch (e) {
        console.error("Error initializing Zoho SalesIQ:", e);
      }
    };

    window.$zoho.salesiq.ready = initializeZohoWidget;

    const script = document.createElement("script");
    script.id = "zsiqscript";
    script.type = "text/javascript";
    script.defer = true;
    script.src = `https://salesiq.zohopublic.in/widget?wc=${WIDGET_CODE}`;

    script.onload = () => {
      setTimeout(() => {
        if (
          window.$zoho &&
          window.$zoho.salesiq &&
          window.$zoho.salesiq.ready
        ) {
          initializeZohoWidget();
        }
      }, 500);
    };

    script.onerror = (error) => {};

    document.body.appendChild(script);

    if (!document.getElementById("zsiqwidget")) {
      const widgetDiv = document.createElement("div");
      widgetDiv.id = "zsiqwidget";
      document.body.appendChild(widgetDiv);
    }

    return () => {
      const script = document.getElementById("zsiqscript");
      if (script) script.remove();
      const widget = document.getElementById("zsiqwidget");
      if (widget) widget.remove();

      if (window.$zoho && window.$zoho.salesiq) {
        try {
          window.$zoho.salesiq.floatwindow.visible("hide");
        } catch (e) {}
      }
    };
  }, [user, userDetail, userFullName, navigate, schoolInfo, userWidgetId]);

  return (
    <div>
      <CreateTicket
        open={openTicketDialog}
        onClose={() => setOpenTicketDialog(false)}
      />
    </div>
  );
};

export default ZohoSalesIQ;
